import { isNil } from 'lodash';
import { currencyFormat, DATETIME_ELEMENT_STYLES, dateTimeFormat } from '@fiverr-private/localization';

const formatCurrency = ({ amount, currency }) => {
    const fallbackValue = `$${amount}`;
    if (isNil(amount) || isNil(currency)) {
        return fallbackValue;
    }

    return currencyFormat(parseFloat(amount), currency, {
        fallbackValue,
    });
};

const formatDate = (date) => {
    if (isNil(date)) {
        return date;
    }

    return dateTimeFormat(new Date(date), {
        year: DATETIME_ELEMENT_STYLES.NUMERIC,
        month: DATETIME_ELEMENT_STYLES.NUMERIC,
        day: DATETIME_ELEMENT_STYLES.NUMERIC,
        fallbackValue: date,
    });
};

export { formatCurrency, formatDate };
